import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'wouter';

const AccessDenied: React.FC = () => {
  const { user, logout } = useAuth();
  const [, setLocation] = useLocation();

  const handleLogout = () => {
    logout();
    setLocation('/');
  };

  const handleGoBack = () => {
    setLocation('/');
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Card style={{ maxWidth: '500px', width: '100%' }}>
        <Card.Body className="text-center p-5">
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
          <Card.Title as="h2" className="mb-3">Access Denied</Card.Title>
          <Card.Text className="text-muted mb-4">
            You do not have permission to access this page. This area is restricted to administrators only.
          </Card.Text>

          {user && (
            <Card.Text className="mb-4">
              <small className="text-muted">
                Current user: <strong>{user.username}</strong> ({user.role})
              </small>
            </Card.Text>
          )}

          <div className="d-grid gap-2">
            <Button
              variant="primary"
              size="lg"
              onClick={handleGoBack}
            >
              Return to Check-In
            </Button>
            <Button
              variant="outline-secondary"
              onClick={handleLogout}
            >
              Logout and Switch User
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AccessDenied;
